import { Info, SampleListItem } from '@analysis/infra/telespot';

export interface CaseNavigationReference {
  caseId: string;
  sampleId: string;
}

export interface NavigationState {
  previousCase: CaseNavigationReference | null;
  nextCase: CaseNavigationReference | null;
  previousSample: string | null;
  nextSample: string | null;
  currentSample: { id: string; name: string };
  currentCase: { id: string; name: string };
  currentWorkspace: { id: string; name: string };
  error: string | null;
  /** Breadcrumb dropdown options for the top level. `null` = not loaded yet. */
  workspaceOptions: Info[] | null;
  /**
   * Case lists per workspace, so the breadcrumb can cascade into any workspace rather
   * than only the open one. `name` may be ciphertext when the workspace is encrypted —
   * consumers should use the decryption-aware `casesByWorkspaceId$` selector.
   *
   * A `null` value means a fetch is pending; a MISSING key means never requested. Both
   * render a loading row, but only the latter should trigger a fetch.
   */
  rawCasesByWorkspaceId: Record<string, Info[] | null>;
  /** Sample lists per case. Same `null` vs missing semantics as `rawCasesByWorkspaceId`. */
  samplesByCaseId: Record<string, SampleListItem[] | null>;
  /** Decrypted case names resolved so far, by case id. */
  decryptedNamesByCaseId: Record<string, string>;
}

export const initialNavigationState: NavigationState = {
  previousCase: null,
  nextCase: null,
  previousSample: null,
  nextSample: null,
  currentSample: null,
  currentCase: null,
  currentWorkspace: null,
  error: null,
  workspaceOptions: null,
  rawCasesByWorkspaceId: {},
  samplesByCaseId: {},
  decryptedNamesByCaseId: {},
};
